import { TrackedInfo } from '../global-constants';

const TRACKING_SESSIONS = new Set();
const TRACKED_PARAMETERS = new Set();
const TRACKED_INFO_SESSIONS = new Set();

TRACKING_SESSIONS.add(TrackedInfo.DDC_REF);
TRACKING_SESSIONS.add(TrackedInfo.GC_LID);
TRACKING_SESSIONS.add(TrackedInfo.T3_WEBSITE);
TRACKING_SESSIONS.add(TrackedInfo.ADP_FOUREYES);

TRACKED_INFO_SESSIONS.add(TrackedInfo.CLLC_MKT_CODES);
TRACKED_INFO_SESSIONS.add(TrackedInfo.PERMANENT_COOKIE_ID);
TRACKED_INFO_SESSIONS.add(TrackedInfo.UNIVERSAL_USER_ID);
TRACKED_INFO_SESSIONS.add(TrackedInfo.USER_PROFILE_ID);
TRACKED_INFO_SESSIONS.add(TrackedInfo.T3_WEBSITE);

TRACKED_PARAMETERS.add(TrackedInfo.CLLC_BID);
TRACKED_PARAMETERS.add(TrackedInfo.CLLC_PID);
TRACKED_PARAMETERS.add(TrackedInfo.CLLC_ADID);
TRACKED_PARAMETERS.add(TrackedInfo.CLLC_RID);

// Currently used for tracking FB promotions leads for FD.
TRACKED_PARAMETERS.add(TrackedInfo.ALT_SOURCE);
// Used to allows for more detailed tracking of leads submitted from custom forms
TRACKED_PARAMETERS.add(TrackedInfo.SECONDARY_LEAD_SOURCE);
TRACKED_PARAMETERS.add(TrackedInfo.FMCCMP);

// Used for tracking Lexus promotions.
TRACKED_PARAMETERS.add(TrackedInfo.CID);
TRACKED_PARAMETERS.add(TrackedInfo.PDSRCH);

// Used for tracking Volvo promotions
TRACKED_PARAMETERS.add(TrackedInfo.REF_ID);

// Used for tracking AOA leads
TRACKED_PARAMETERS.add(TrackedInfo.ADOBE_CLOUD_ID);

// Used for tracking honda leads
TRACKED_PARAMETERS.add(TrackedInfo.UTM_CAMPAIGN);
TRACKED_PARAMETERS.add(TrackedInfo.UTM_MEDIUM);
TRACKED_PARAMETERS.add(TrackedInfo.UTM_SOURCE);
TRACKED_PARAMETERS.add(TrackedInfo.ADS_ADGROUP);
TRACKED_PARAMETERS.add(TrackedInfo.ADS_ADID);
TRACKED_PARAMETERS.add(TrackedInfo.ADS_DIGADPROVIDER);

// For Bank of America
TRACKED_PARAMETERS.add(TrackedInfo.MARKETING_CODE);
TRACKED_PARAMETERS.add(TrackedInfo.ZIP);

const TRACKED_ATTRIBUTES = new Set([
	...TRACKING_SESSIONS,
	...TRACKED_PARAMETERS
]);
TRACKED_ATTRIBUTES.add(TrackedInfo.SESSION_REFERRER_DOMAIN);
TRACKED_ATTRIBUTES.add(TrackedInfo.CAMPAIGN_PARAMS);
TRACKED_ATTRIBUTES.add(TrackedInfo.CONTACT_ID);
TRACKED_ATTRIBUTES.add(TrackedInfo.REACHLOCAL_COOKIE);
TRACKED_ATTRIBUTES.add(TrackedInfo.SEM_ID);
TRACKED_ATTRIBUTES.add(TrackedInfo.REGION_ID);
TRACKED_ATTRIBUTES.add(TrackedInfo.KEYWORD_ID);

const TRACKED_ATTRS_NAME = 'ddcstdata';
const V9_TYPE = 'v9';

const setSessionItem = (key, value) => {
	if (!value) {
		return;
	}
	sessionStorage.setItem(key, value);
};

const getSessionItem = (key) => {
	const validKey = key && key !== '';
	if (validKey) {
		return sessionStorage.getItem(key);
	} else {
		return null;
	}
};

const parseTrackedAttributeData = (urlParams) => {
	let attributes = new Map();
	const trackedData =
		urlParams[TRACKED_ATTRS_NAME] ||
		sessionStorage.getItem(TRACKED_ATTRS_NAME);
	if (!trackedData) {
		return;
	}

	const decodeTrackedData = atob(trackedData);
	attributes = decodeTrackedData.split('&').map((data) => {
		const dataArr = data.split('=');
		return {
			key: dataArr[0],
			value: dataArr[1]
		};
	});
	attributes.forEach(({ key, value }) => {
		const trackValue = value ? decodeURI(value) : null;
		sessionStorage.setItem(key, trackValue);
	});
};

const setTrackedDataFromParams = (trackingNames, urlParams) => {
	trackingNames.forEach((trackName) => {
		const trackValue = urlParams[trackName];
		// remove session if no tracValue found
		if (!trackValue) {
			sessionStorage.removeItem(trackName);
		} else {
			setSessionItem(trackName, trackValue);
		}
	});
};

const setTrackedDataFromSessionStorage = (trackingNames) => {
	trackingNames.forEach((trackName) => {
		const trackValue = getSessionItem(trackName);
		setSessionItem(trackName, trackValue);
	});
};

const verifyExistAttributes = (
	trackingNames,
	verifySession = true,
	hasAll = false
) => {
	// eslint-disable-next-line no-restricted-syntax
	for (const trackingName of trackingNames) {
		const val = verifySession
			? getSessionItem(trackingName)
			: window?.DDC?.getUrlParams()[trackingName];
		// If hasAll = true Return false if there is any null value
		if (!val && hasAll) {
			return false;
			// If hasAll = false Return true if there is any not null value
		} else if (!hasAll && val) {
			return true;
		}
	}
	return hasAll;
};

const processTrackedData = (trackingNames, urlParams) => {
	if (verifyExistAttributes(trackingNames, false)) {
		setTrackedDataFromParams(trackingNames, urlParams);
	}

	if (!verifyExistAttributes(trackingNames)) {
		setTrackedDataFromSessionStorage(trackingNames);
	}
};

const saveTrackedAttributeData = () => {
	const attributes = new Map();
	TRACKED_ATTRIBUTES.forEach((key) => {
		const attrValue = sessionStorage.getItem(key);
		if (!attrValue) {
			return;
		}
		attributes.set(key, encodeURI(attrValue));
	});
	if (attributes.size === 0) {
		sessionStorage.removeItem(TRACKED_ATTRS_NAME);
		return;
	}

	const trackedData = btoa(
		Array.from(attributes.entries())
			.map(([key, value]) => `${key}=${value}`)
			.join('&')
	);
	if (trackedData !== sessionStorage.getItem(TRACKED_ATTRS_NAME)) {
		setSessionItem(TRACKED_ATTRS_NAME, trackedData);
	}
};

const updateSession = (urlParams) => {
	// TODO: Check not isBot value return from Akamai
	const isBotOrComposer = window?.DDC.isComposer;
	if (!isBotOrComposer) {
		parseTrackedAttributeData(urlParams);
	}

	processTrackedData(TRACKING_SESSIONS, urlParams);

	// Update session for TRACKED_PARAMETERS
	TRACKED_PARAMETERS.forEach((key) => {
		const attrValue = urlParams[key];
		setSessionItem(key, attrValue);
	});

	const tcParam = urlParams.tc;
	setSessionItem(TrackedInfo.SEM_ID, tcParam);

	const kwParam = urlParams.kw;
	if (kwParam) {
		const kwParamSplit = kwParam.split(':');
		if (kwParamSplit.length > 1) {
			setSessionItem(TrackedInfo.REGION_ID, kwParamSplit[1]);
		}
		setSessionItem(TrackedInfo.KEYWORD_ID, kwParamSplit[0]);
	}

	const fromParam = urlParams.from;
	if (fromParam === 'AcuraInventory') {
		setSessionItem(TrackedInfo.DDC_REF, fromParam);
	}

	const semSession = getSessionItem(TrackedInfo.SEM_ID);

	if (semSession && semSession.includes('tc=')) {
		const start = semSession.indexOf('tc=') + 3;
		const end = semSession.indexOf('&', start);
		let dominatorid = null;
		if (end < 0) {
			dominatorid = semSession.substring(start);
		} else {
			dominatorid = semSession.substring(start, end);
		}
		setSessionItem(TrackedInfo.SEM_ID, dominatorid);
		setSessionItem(TrackedInfo.REACHLOCAL_COOKIE, semSession);
	}
	// TODO: Check not isBot to saveTrackedAttributeData
	if (!isBotOrComposer) {
		saveTrackedAttributeData();
	}

	window.dispatchEvent(new Event('ws-tracking-get-tracked-info-ready'));
};

const getTrackedInfo = (locale = 'en_US', urlParams = {}, type = null) => {
	const trackInfo = {};
	trackInfo.timestamp = new Date();
	const attributes = new Map();
	attributes.set(TrackedInfo.TYPE, `${type}`);
	attributes.set(
		TrackedInfo.USER_SESSION_ID,
		getSessionItem(TrackedInfo.USER_SESSION_ID)
	);
	attributes.set(TrackedInfo.REFERRER, document.referrer);
	attributes.set(TrackedInfo.USER_AGENT, navigator.userAgent);
	// TODO: Should move get REMOTE_HOST based on akamai
	if (type === TrackedInfo.FORM_SUBMIT) {
		const sessionReferrer =
			urlParams.userSessionReferrer ||
			getSessionItem(TrackedInfo.SESSION_REFERRER_DOMAIN).toString() ||
			'';
		attributes.set(TrackedInfo.SESSION_REFERRER, sessionReferrer);
	}
	TRACKED_ATTRIBUTES.forEach((attr) =>
		attributes.set(attr, getSessionItem(attr))
	);
	TRACKED_INFO_SESSIONS.forEach((trackedInfoSessionName) => {
		const trackedInfoSessionValue = getSessionItem(trackedInfoSessionName);
		if (trackedInfoSessionValue) {
			attributes.set(trackedInfoSessionName, trackedInfoSessionValue);
		}
	});
	if (attributes.get(TrackedInfo.CONTACT_ID) === '') {
		const contactIdSessionValue = getSessionItem(TrackedInfo.CONTACT_ID);
		if (contactIdSessionValue) {
			attributes.set(TrackedInfo.CONTACT_ID, contactIdSessionValue);
		}
	}
	//  TODO: Considering to set/get LOCALE from Akamai
	attributes.set(TrackedInfo.LOCALE, locale);

	// TODO: Find the way to get other site property: PORTAL_ID
	const { siteSettings, dataLayer } = window?.DDC;
	if (siteSettings) {
		attributes.set(TrackedInfo.SITE_ID, siteSettings?.siteId);
		attributes.set(TrackedInfo.SKIN, dataLayer?.site?.design?.themekit);
		attributes.set(
			TrackedInfo.VERSION,
			dataLayer?.site?.design?.variationId
		);
		attributes.set(TrackedInfo.PLATFORM, V9_TYPE);
		// TODO: condition to getHomepage then set TEMPLATE_EXTRA attribute
	}

	// TODO: consider add logic for Variant variant

	const userProfileIdOverride = urlParams.connectionId;
	if (userProfileIdOverride && userProfileIdOverride !== '') {
		attributes.set(TrackedInfo.USER_PROFILE_ID, userProfileIdOverride);
	}

	trackInfo.attributes = attributes;
	return trackInfo;
};

export { updateSession, getTrackedInfo };
